var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getRoleAwareUrl = function (url, viewerKind) {
    if (viewerKind === 'brand') {
        return "/brand".concat(url);
    }
    if (viewerKind === 'barber') {
        return "/barber".concat(url);
    }
    return url;
};
export var getRoleAwareTo = function (to, viewerKind) {
    if (typeof to === 'string') {
        return getRoleAwareUrl(to, viewerKind);
    }
    if (typeof to === 'function') {
        return function (props) {
            var result = to(props);
            result.pathname = getRoleAwareUrl(result.pathname, viewerKind);
            return result;
        };
    }
    if (typeof to === 'object' && (to === null || to === void 0 ? void 0 : to.pathname)) {
        return __assign(__assign({}, to), { pathname: getRoleAwareUrl(to.pathname, viewerKind) });
    }
    return to;
};
